/** @format */

const TODAY_IMAGE = 'assets/image/today.svg';

export const PDP_CONSTANTS = {
	appPathPrefix: 'p',
	adeptmindScriptPath: 'https://www.dickssportinggoods.com/a/js/pdpScript.js',
	DEFAULT_SHIPPING_MESSAGES: [
		{
			type: 'Standard',
			show: false,
			message: 'Standard Ground Shipping Available',
			subMessage: '',
			innerHtml: '',
			emsName: 'shipping-information',
			showImage: false,
			image: '',
			imageClass: '',
			order: 1
		},
		{
			type: 'PreOrder',
			show: false,
			message: 'Pre-Order Product',
			subMessage: '',
			innerHtml: '',
			emsName: 'item-availability',
			showImage: true,
			image: TODAY_IMAGE,
			imageClass: '',
			order: 2
		},
		{
			type: 'Restriction',
			show: false,
			message: 'Sale & Shipping Restrictions.',
			subMessage: '',
			innerHtml: '',
			emsName: 'sale-and-shipping-restrictions',
			showImage: true,
			image: 'assets/image/not-interested.svg',
			imageClass: 'red-image',
			order: 3
		},
		{
			type: 'OP',
			show: false,
			message: 'Oversized Shipping Charges Apply.',
			subMessage: '',
			innerHtml: '',
			emsName: 'shipping-information',
			showImage: true,
			image: 'assets/image/monetization.svg',
			imageClass: '',
			order: 4
		},
		{
			type: 'LeadTime',
			show: false,
			message: '',
			subMessage: '',
			innerHtml: '',
			emsName: 'item-availability',
			showImage: true,
			image: TODAY_IMAGE,
			imageClass: '',
			order: 5
		},
		{
			type: 'LTL',
			show: false,
			message: 'Requires scheduled delivery. Assembly options may be available.',
			subMessage: '',
			innerHtml: '',
			emsName: 'shipping-information',
			showImage: true,
			image: TODAY_IMAGE,
			imageClass: '',
			order: 6
		}
	],
	leadingZeroDoubleDigits: ['01', '02', '03', '04', '05', '06', '07', '08', '09'],
	singleDigits: {
		low: ['1', '2', '3', '4'],
		all: ['1', '2', '3', '4', '5', '6', '7', '8', '9']
	},
	product: {
		floorModelQuantity: 1,
		badge: {},
		quantity: {
			maxQuantity: 99,
			minQuantity: 1
		}
	},
	refreshAddToCartTimeout: 20000,
	pdpJsonFileName: {
		bannedWords: 'banned-words-091019.json',
		brandsData: 'brands-data-09152021.json',
		categoriesData: 'categories-data-11102021.json',
		ecodesData: 'ecodes-data-04102020.json',
		shippingMessages: 'shipping-messages-01292025.json',
		exclusiveContent: 'exclusive-content.json'
	},
	infoSummaryAttribute: {
		ids: ['2571', '2617', '2527', '1511', '2568', '2567', '2564', '5576', '1739'],
		values: ['Mountain', 'Sleeping Bags', 'Tents']
	},
	footwearApparelAttrNames: ['color', 'shoesize', 'shoewidth', 'size', 'inseam', 'length'],
	footwearAttrNames: ['shoesize', 'shoewidth'],
	exclusiveBrands: ['Nike', 'Gold'],
	partyAttributes: {
		nike: 'nike_connected',
		gold: 'gold'
	},
	exclusiveCTATypes: {
		nike: {
			loggedIn: 'connectAccounts',
			notLoggedIn: 'signIn'
		},
		gold: {
			loggedIn: 'locked',
			notLoggedIn: 'lockedSignIn'
		}
	},
	exclusiveApeValue: {
		nike: 'Nike APE Exclusive',
		gold: 'Gold APE Exclusive'
	},
	partyAttrText: 'partyAttributes'
};
